import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, unref as _unref } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "editable-cell"
}
const _hoisted_2 = { class: "editable-cell-input-wrapper" }
const _hoisted_3 = {
  key: 1,
  class: "editable-cell"
}
const _hoisted_4 = { class: "editable-cell-input-wrapper" }
const _hoisted_5 = {
  key: 2,
  class: "editable-cell"
}
const _hoisted_6 = { class: "editable-cell-input-wrapper" }
const _hoisted_7 = {
  key: 3,
  class: "editable-cell"
}
const _hoisted_8 = { class: "editable-cell-input-wrapper" }

import { onMounted, PropType, reactive, toRaw, watch } from 'vue';
import { Modal } from 'ant-design-vue';
import { ProjectDataItem } from '@/@types/version-manage/Product';
import { cloneDeep } from 'lodash';

interface IEmit {
  (e: 'on-cancel'): void;
  (
    e: 'on-submit',
    value: {
      versionData: ProjectDataItem[];
      projectId?: number;
    },
  ): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'VersionDetailEditorModal',
  props: {
  visible: {
    type: Boolean,
    default: false,
  },
  versionData: {
    type: Array as PropType<ProjectDataItem[]>,
    default: () => [],
  },
  projectId: {
    type: Number,
    default: undefined,
  },
},
  emits: ["on-cancel", "on-submit"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'on-cancel'): void;
  (
    e: 'on-submit',
    value: {
      versionData: ProjectDataItem[];
      projectId?: number;
    },
  ): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;



const state = reactive({
  dataSource: [] as ProjectDataItem[],
});

/** 删除字段 */
const onDelete = (index: number) => {
  Modal.confirm({
    content: '是否删除该字段?',
    onOk: () => {
      state.dataSource = state.dataSource.filter((_, i) => index !== i);
    },
  });
};

const columns = [
  {
    title: '类型',
    dataIndex: 'type',
    width: '20%',
  },
  {
    title: '标签',
    dataIndex: 'label',
    width: '20%',
  },
  {
    title: '内容',
    dataIndex: 'value',
    width: '30%',
  },
  {
    title: '宽度',
    dataIndex: 'width',
    width: '15%',
  },
  {
    title: '操作',
    dataIndex: 'operation',
    width: '15%',
  },
];

const refreshDataSource = () => {
  state.dataSource = cloneDeep(toRaw(props.versionData));
};

onMounted(refreshDataSource);

watch(() => props.versionData, refreshDataSource);
/** 点击添加新字段按钮 */
const toogleAddNewField = () => {
  state.dataSource.push({
    label: '',
    value: '',
    width: 8,
    type: 'basic',
  });
};
/** 提交数据 */
const submitVersionData = () => {
  emits('on-submit', {
    versionData: state.dataSource,
    projectId: props.projectId,
  });
};

/** 点击提交按钮 */
const onsubmit = () => {
  Modal.confirm({
    title: '保存确认',
    content: '保存当前修改?',
    onOk: submitVersionData,
  });
};

/** 点击取消按钮 */
const onCancel = () => {
  Modal.confirm({
    title: '保存确认',
    content: '是否保存当前修改?',
    onOk: submitVersionData,
    onCancel: () => {
      refreshDataSource();
      emits('on-cancel');
    },
    okText: '保存',
    cancelText: '不保存',
  });
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createBlock(_unref(Modal), {
    title: "编辑软件信息",
    visible: props.visible,
    width: "1000px",
    onOk: onsubmit,
    onCancel: onCancel
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_button, {
        type: "primary",
        class: "editable-add-btn",
        style: {"float":"right","margin-bottom":"8px"},
        onClick: toogleAddNewField
      }, {
        default: _withCtx(() => [
          _createTextVNode("添加属性")
        ]),
        _: 1
      }),
      _createVNode(_component_a_table, {
        bordered: "",
        "data-source": state.dataSource,
        columns: columns,
        pagination: false
      }, {
        bodyCell: _withCtx(({ column, index, record }) => [
          (column.dataIndex === 'type')
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_a_select, {
                    value: state.dataSource[index][column.dataIndex],
                    "onUpdate:value": ($event: any) => ((state.dataSource[index][column.dataIndex]) = $event),
                    "dropdown-match-select-width": false,
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, { value: "basic" }, {
                        default: _withCtx(() => [
                          _createTextVNode("普通标签")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "split" }, {
                        default: _withCtx(() => [
                          _createTextVNode("分割线")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: "version" }, {
                        default: _withCtx(() => [
                          _createTextVNode("当前版本号")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["value", "onUpdate:value"])
                ])
              ]))
            : _createCommentVNode("", true),
          (column.dataIndex === 'label')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  (record.type === 'basic')
                    ? (_openBlock(), _createBlock(_component_a_input, {
                        key: 0,
                        value: record[column.dataIndex],
                        "onUpdate:value": ($event: any) => ((record[column.dataIndex]) = $event)
                      }, null, 8, ["value", "onUpdate:value"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (column.dataIndex === 'value')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  (record.type === 'basic')
                    ? (_openBlock(), _createBlock(_component_a_input, {
                        key: 0,
                        value: record[column.dataIndex],
                        "onUpdate:value": ($event: any) => ((record[column.dataIndex]) = $event)
                      }, null, 8, ["value", "onUpdate:value"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (column.dataIndex === 'width')
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_a_select, {
                    value: record[column.dataIndex],
                    "onUpdate:value": ($event: any) => ((record[column.dataIndex]) = $event),
                    "dropdown-match-select-width": false,
                    style: {"width":"100px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, { value: 6 }, {
                        default: _withCtx(() => [
                          _createTextVNode("四分之一")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: 8 }, {
                        default: _withCtx(() => [
                          _createTextVNode("三分之一")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: 12 }, {
                        default: _withCtx(() => [
                          _createTextVNode("二分之一")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: 24 }, {
                        default: _withCtx(() => [
                          _createTextVNode("占满整行")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["value", "onUpdate:value"])
                ])
              ]))
            : (column.dataIndex === 'operation')
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 4,
                  type: "link",
                  onClick: ($event: any) => (onDelete(index))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("删除")
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["data-source"])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})